export default __webpack_public_path__ + "static/media/EnerginetLogo.e2f808fb.png";